import Heading, { HeadingProps } from './Heading';

export default Heading;
export type { HeadingProps };
